import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getVoucherApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  if (data?.code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isVoucherVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT'
    || error?.response?.status === 409;
}
